import { createQueryKeySet } from '@akin-home/utils/react-query';

export const contactsQueryKeySet = createQueryKeySet({ key: 'contacts' });
